The number of weeks of notice a candidate needs to provide to their current employer to switch jobs.
